module.exports = __webpack_public_path__ + "static/media/HCMM600.8712dac3.jpg";